import { Skeleton } from '@mui/material';
import useAccessibleAccounts from '@/hooks/useAccessibleAccounts';
import AccountSwitcher from '../AccountSwitcher';
import BusinessSwitcher from './BusinessSwitcher';

// O seletor de conta e negócio (CBK-595) só entra quando o backend liga a rota das
// contas. Até lá, e para o suporte que impersona, segue o seletor de negócio.
export default function NavSwitcher() {
  const { accounts, currentAccount, isAvailable, isLoading } = useAccessibleAccounts();

  if (isLoading) {
    return <Skeleton variant="rounded" height={72} sx={{ borderRadius: 2 }} />;
  }

  if (isAvailable) {
    return <AccountSwitcher accounts={accounts} currentAccount={currentAccount} />;
  }

  return <BusinessSwitcher />;
}
